import _t from 'i18n!nls/learner-skills';

export const MAX_SCORE_CONVERSANT = 50;
export const MAX_SCORE_BEGINNER = 150;
export const MAX_SCORE_INTERMEDIATE = 350;
export const MAX_SCORE_ADVANCED = 500;
export const SKILL_LEVEL_SEGMENTS = [MAX_SCORE_CONVERSANT, MAX_SCORE_BEGINNER, MAX_SCORE_INTERMEDIATE];

export type SkillsetLevel = 'conversant' | 'beginner' | 'intermediate' | 'advanced';

export const getCurrentLevel = (score: number): SkillsetLevel => {
  if (score <= MAX_SCORE_CONVERSANT) return 'conversant';
  if (score <= MAX_SCORE_BEGINNER) return 'beginner';
  if (score <= MAX_SCORE_INTERMEDIATE) return 'intermediate';
  return 'advanced';
};

export const getLevelNames = (): { [level in SkillsetLevel]: string } => ({
  conversant: _t('Conversant'),
  beginner: _t('Beginner'),
  intermediate: _t('Intermediate'),
  advanced: _t('Advanced'),
});

export const getLevelName = (score: number) => getLevelNames()[getCurrentLevel(score)];

// For each skill with score increase, display skill score with score increase from this assessment and competency statement about new level

export const getLevelDescription = (score: number) => {
  return {
    conversant: _t(
      'Keep going! At a conversant level, you have familiarity with the vocabulary and are able to pass easy content.'
    ),
    beginner: _t(
      'Keep going! At a beginner level, you have a working knowledge and are able to pass beginner content. You have limited experience applying it.'
    ),
    intermediate: _t(
      'Well done! At an intermediate level, you have a solid understanding of the material and are able to pass intermediate content. You can apply key concepts on most tasks.'
    ),
    advanced: _t(
      'Well done! At an advanced level, you have a mastery of the material and are able to pass advanced content. You can both teach others and identify novel applications of this skill.'
    ),
  }[getCurrentLevel(score)];
};
